<template>
    <div class="form-container">
        <template v-if="isAuth">
            <div class="form">
                <div class="inputs-container">
                    <h2>Add Note</h2>
                    <p class="form-subheading">Add a private note about this vendor.</p>
                    <div class="form-fields">
                        <div :class="{ error: v$.note.$errors.length }">
                            <textarea v-model="state.note" @blur="v$.note.$touch"></textarea>
                            <div class="input-errors" v-for="error of v$.note.$errors" :key="error.$uid">
                                <div class="error-msg">{{ error.$message }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-buttons">
                        <button class="forward-btn note-btn" @click="addNote">Add Note</button>
                    </div>

                </div>
            </div>

            <div class="list-container">
                <ul>
                    <li v-for="note in notes" :key="note.id" :class="[{ 'note-active': editNoteId == note.id }, 'note' ]">
                        <div v-if="editNoteId == note.id">
                            <div :class="{ error: v$.editNote.$errors.length }">
                                <textarea v-model="state.editNote" @blur="v$.editNote.$touch"></textarea>
                                <div class="input-errors" v-for="error of v$.editNote.$errors" :key="error.$uid">
                                    <div class="error-msg">{{ error.$message }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="note-row">
                            <div>
                                <span class="comment" v-if="editNoteId != note.id">{{ note.comment }}</span><br />
                                <span class="text-subdued">Created by {{ note.user }} on {{ displayDate(note.date) }}</span>
                            </div>
                            <div class="list-actions">
                                <button class="edit-btn" v-if="editNoteId != note.id" @click="editNote(note.id)">
                                    <fa-icon :icon="['fas', 'pen']" aria-hidden="true"></fa-icon>Edit
                                </button>
                                <button class="delete-btn" v-if="editNoteId != note.id" @click="deleteNote(note.id)">
                                    <fa-icon :icon="['fas', 'trash']" aria-hidden="true"></fa-icon>Delete
                                </button>

                                <button class="cancel-btn" v-if="editNoteId == note.id" @click="cancelNote">Cancel</button>
                                <button class="edit-btn" v-if="editNoteId == note.id" @click="saveNote(note.id)">Save</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="form-button-cancel form-buttons">
                <button class="cancel-btn close-notes" @click="closeForm">Close</button>
            </div>

        </template>
        <template v-else>
            <marketing-action class="py-0" :more-info-url="moreInfoUrl">
                <template #heading>
                    <h2>Add Note</h2>
                    <p>Add a private note about this vendor.</p>
                </template>
                <template #subheading>
                    <h3>This is a free feature available to logged-in accounts</h3>
                    <h4>Create a <strong>free account</strong> or <strong>login</strong> to add notes related to this vendor!</h4>
                </template>
            </marketing-action>
        </template>
    </div>
</template>

<script>import script from './ListingNotes';
    export default script;</script>

<style lang="less" scoped>
    @import "./ListingNotes.less";
</style>
